"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#374151",
  d: "M16.757 15.954h-2.39l-1.173-3.039H6.09l-1.173 3.04H2.526L8.284 1.263H11zm-4.194-5L9.63 3.179l-2.91 7.775zm8.104 5h-2.173V1.263h2.173z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#374151",
  fillRule: "evenodd",
  d: "M4.32 18.044c3.685 5.213 11.419 5.213 15.104 0l1.67 1.181c-4.499 6.366-13.944 6.366-18.443 0z",
  clipRule: "evenodd"
})), 'StoryboardAiLogoLight');

exports.default = _default;